declare function PostAffTracker(): void

export function profiliatePostCustomer() {
  ;(PostAffTracker as any).writeCookieToCustomField('pap_tdx8v2s5a')
}
